import { SendDownloadLinksFormWebComponent } from './component/SendDownloadLinksFormWebComponent';
import { WEB_COMPONENT_SEND_DOWNLOAD_LINKS_FORM } from '../../webcomponents.constants';

export { SendDownloadLinksFormWebComponent };

window.customElements.define(WEB_COMPONENT_SEND_DOWNLOAD_LINKS_FORM, SendDownloadLinksFormWebComponent);
